/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActivityTrackerPreferenceRequest
 */
export interface ActivityTrackerPreferenceRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ActivityTrackerPreferenceRequest
     */
    granularActivityTracker: boolean;
}

/**
 * Check if a given object implements the ActivityTrackerPreferenceRequest interface.
 */
export function instanceOfActivityTrackerPreferenceRequest(value: object): value is ActivityTrackerPreferenceRequest {
    if (!('granularActivityTracker' in value) || value['granularActivityTracker'] === undefined) return false;
    return true;
}

export function ActivityTrackerPreferenceRequestFromJSON(json: any): ActivityTrackerPreferenceRequest {
    return ActivityTrackerPreferenceRequestFromJSONTyped(json, false);
}

export function ActivityTrackerPreferenceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityTrackerPreferenceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'granularActivityTracker': json['granularActivityTracker'],
    };
}

export function ActivityTrackerPreferenceRequestToJSON(value?: ActivityTrackerPreferenceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'granularActivityTracker': value['granularActivityTracker'],
    };
}

